import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  word: '',
  syllables: 0,
};

const instructionReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_INSTRUCTION_WORD_AND_SYLLABLES:
      return {
        ...state,
        word: payload.word,
        syllables: payload.syllables,
      };

    case REDUX_ACTIONS.CLEAR_INSTRUCTION_WORD_AND_SYLLABLES:
      return initialState;

    default:
      return state;
  }
};

export default instructionReducer;
